import SectionHeader from './SectionHeader';

const steps = [
  {
    icon: 'ri-grid-fill',
    step: '01 · 分类',
    title: '先定方向',
    desc: '影视、综艺、明星、网红等 9 大分类划清板块边界，避免大海捞针。',
    tone: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-price-tag-3-line',
    step: '02 · 标签',
    title: '锁定特征',
    desc: '用大结局、官宣阵容等标签筛出同一特征，缩小检索范围。',
    tone: 'bg-secondary-100 text-secondary-800',
  },
  {
    icon: 'ri-refresh-line',
    step: '03 · 栏目',
    title: '定期追更',
    desc: '固定更新频率的栏目，让喜欢的板块随时可追、不断更。',
    tone: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-folders-line',
    step: '04 · 专题',
    title: '补全脉络',
    desc: '专题把同类话题整理成完整目录，一次看全一段来龙去脉。',
    tone: 'bg-primary-100 text-primary-700',
  },
];

export default function Layers() {
  return (
    <section className="border-b border-background-200/70 bg-background-50 py-14 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="How It Works"
          title="四步定位你关心的板块"
          desc="导航吃瓜用一套由粗到细的内容架构组织信息：分类划边界，标签锁特征，栏目追更新，专题补脉络，板块与目录贯穿始终。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative overflow-hidden rounded-2xl border border-background-200/80 bg-background-100/50 p-5"
            >
              <span className="absolute right-4 top-4 font-display text-4xl text-background-200/70" aria-hidden="true">
                0{i + 1}
              </span>
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl ${s.tone}`}>
                <i className={s.icon} aria-hidden="true"></i>
              </span>
              <p className="mt-4 text-xs font-semibold uppercase tracking-wide text-foreground-400">{s.step}</p>
              <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}